<template>
  <div id="app"
       :style="`min-height:${bgHeight}`"
       class="colorBlue">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      bgHeight: '100%'
    }
  },
  mounted () {
    if (!document.documentElement.style['font-size'] && window.recalc) {
      window.recalc()
    }
    this.bgHeight = document.body.offsetHeight + 'px'
    // if (!document.querySelector('.webapiAmap')) {
    //   const scr = document.createElement('script')
    //   scr.classList.add('webapiAmap')
    //   scr.src = 'https://webapi.amap.com/maps?v=1.4.15&key=b10aded571a07c56987fa0982e533c25'
    //   scr.type = 'text/javascript'
    //   document.body.appendChild(scr)
    // }
  }
}

</script>

<style lang="less">
@import "~@/assets/less/reset";
@import "~@/assets/less/theme";
@import "~@/assets/less/base";
@import "~@/assets/less/tailwindcss";
@import "~@/assets/less/flex";

#app {
  height: 100%;
}
</style>
